export default "__VITE_ASSET__DHOT3Nmb__"